"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _iconAlertCircleFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-alert-circle-fill-extra-small"));
var _iconAlertTriangleFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-alert-triangle-fill-extra-small"));
var _layout = require("../../layout");
var _utils = require("../../utils");
var _InputFooterIcon = _interopRequireDefault(require("./InputFooterIcon"));
var _InputFooterText = _interopRequireDefault(require("./InputFooterText"));
var _constants = require("./constants");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const iconRenderer = _ref => {
  let {
    warning,
    error,
    iconAltText,
    icon: providedIcon
  } = _ref;
  const icon = providedIcon === null ? null : providedIcon || (error ? (0, _react2.jsx)(_iconAlertCircleFillExtraSmall.default, {
    title: iconAltText || 'Error'
  }) : warning ? (0, _react2.jsx)(_iconAlertTriangleFillExtraSmall.default, {
    title: iconAltText || 'Warning'
  }) : null);
  return icon ? (0, _react2.jsx)(_InputFooterIcon.default, {
    error: error,
    warning: warning
  }, icon) : null;
};
const InputFooterBase = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    children,
    warning,
    error,
    icon,
    gridGap = _constants.INPUT_GRID_GAP,
    alignItems = 'flex-start',
    iconAltText,
    ...transferProps
  } = _ref2;
  return (0, _react2.jsx)(_layout.Row, (0, _extends2.default)({
    ref: ref,
    gridGap: gridGap,
    alignItems: alignItems
  }, transferProps), iconRenderer({
    warning,
    error,
    icon,
    iconAltText
  }), !!children ? typeof children === 'string' ? (0, _react2.jsx)(_InputFooterText.default, null, children) : children : null);
});
const InputFooterWithDocs = (0, _stencilReactDesc.describe)(InputFooterBase).description('Used in conjunction with form components to display additional information related to a form field');
InputFooterWithDocs.propTypes = {
  ..._layout.Row.describedPropTypes,
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the InputFooter. Normally a plain string.'),
  icon: _stencilReactDesc.PropTypes.any.description('Icon to display on the left of the InputFooter.').format('component type'),
  error: _stencilReactDesc.PropTypes.bool.description('Styles the field to indicate that the value is incorrect and cannot be used.'),
  warning: _stencilReactDesc.PropTypes.bool.description("Styles the field to indicate that it requires the user's attention."),
  iconAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the icon displayed on the leading side of the footer. The text should be tailored to the type of footer.')
};
const InputFooter = (0, _utils.withTestAttributes)({
  component: 'StencilReactInputFooter'
})(InputFooterWithDocs);
InputFooter.displayName = 'InputFooter';
var _default = exports.default = InputFooter;